import {
  isLeadInfoValid, onFocus, pushRegInfoToGTM, showPlansFold,
} from '../components/util/registerUtil';
import {
  LEAD_REGISTRATION_API, BRANDID,
} from './constants';
import { setCookie, getCookieValue } from './cookie';

let leadInfo = {};
let lPRegisterLeadInfo = {};
const registerBtn = document.querySelector('#register');
const lPRegisterBtn = document.querySelector('#lp-register-btn');
const lpPageCta = document.getElementById('lp-ppc-cta');
const isFromMailchimpEmailCampaign = window.location.search === '?utm_source=mailchimp+&utm_medium=email+campaign&utm_campaign=30for3';
const isFromLegalIntakeGuide = window.location.pathname.includes('/ca/legal-intake-guide');
const isReferAFriendPage = window.location.pathname.includes(
  '/ca/redeem-your-referral',
);
const isFromVanityUrl = window.location.search === '?utm_source=event&utm_medium=events&utm_campaign=LEX+Reception+events';

function hideRegisterFormAndShowThankYouSectionForLpPage(eventTarget) {
  if (eventTarget === 'lp-register-btn') {
    document.getElementById('lp-top-registration-sec').classList.add('d-none');
    document.getElementById('thank-you-top-section').classList.remove('d-none');

    const lpBottomRegFold = document.getElementById('lp-bottom-reg-fold');
    const lpTopRegFold = document.getElementById('lp-top-reg-fold');

    if (lpBottomRegFold) lpBottomRegFold.classList.add('d-none');
    if (lpTopRegFold) lpTopRegFold.classList.add('registered');

    if (isFromLegalIntakeGuide) {
      const heroSection = document.querySelector('.hero');
      if (heroSection) heroSection.classList.add('is-registered');
    }
  } else {
    document.getElementById('lp-register-bottom-sec').classList.add('d-none');
    document.getElementById('thank-you-bottom-section').classList.remove('d-none');
    document.getElementById('lp-top-reg-fold').classList.add('d-none', 'registered');
  }
}

if (getCookieValue('registeredForContest')) {
  const name = document.querySelector('#name');
  const email = document.querySelector('#email');
  const phone = document.querySelector('#phone');
  name.value = getCookieValue('name');
  email.value = getCookieValue('mail');
  phone.value = getCookieValue('phone');
}


function onBlur(event, info) {
  if (event.target.id.includes('lp-register')) {
    lPRegisterLeadInfo[info.emittedBy] = info;
  } else if (document.getElementsByClassName('js-modal-active').length === 0) {
    leadInfo[info.emittedBy] = info;
  }
}

function leadInfoObject(phoneFieldID, emailFieldID, companyFieldID, nameFieldID) {
  return {
    fields: {
      phone: {
        selector: phoneFieldID,
        type: 'phone',
        withDialCodePicker: true,
        country: (window.siteInfo && window.siteInfo.country) || 'CA',
        errorClassName: 'is-invalid',
      },
      ...(document.getElementById('company') && {
        company: {
          selector: companyFieldID,
          type: 'text',
          errorClassName: 'is-invalid',
        },
      }),

      mail: { selector: emailFieldID, type: 'email', errorClassName: 'is-invalid' },
      ...(!!document.querySelector(companyFieldID) && {
        company: {
          selector: companyFieldID,
          type: 'text',
          errorClassName: 'is-invalid',
        },
      }),
      name: { selector: nameFieldID, type: 'text', errorClassName: 'is-invalid' },
    },
    eventListeners: {
      blur: onBlur,
      focus: onFocus,
    },
  };
}

leadInfo = window.InputValidator && window.InputValidator.fields.initialize({
  ...leadInfoObject('#phone', '#email', '#company', '#name'),
});

lPRegisterLeadInfo = window.InputValidator && window.InputValidator.fields.initialize({
  ...leadInfoObject('#lp-register-phone', '#lp-register-email', '#lp-register-company', '#lp-register-name'),
});

function setEventCookieIfRequired() {
  if (isFromMailchimpEmailCampaign) {
    setCookie('isFromMailchimpEmailCampaign', true, 30);
  }
  if (isFromVanityUrl) {
    setCookie('isFromVanityUrl', true, 365);
  }
  if (isFromLegalIntakeGuide) {
    setCookie('isLegalIntakeGuideBannerClosed', true, 365);
    window.open(
      'https://assets.lexreception.com/lexreception/pdf/lex-ca-legal-intake-guide.pdf',
      '_ blank',
    );
  }
}

async function processLeadRegistration(payload, eventTarget) {
  try {
    let response = await window.fetch(LEAD_REGISTRATION_API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    });
    response = await response.json();
    if (response && Object.keys(response).length) {
      const { UniquePIN, signupurl } = response;
      if (UniquePIN && signupurl) {
        pushRegInfoToGTM(response);
        setCookie('isregistered', true, 365);
        setCookie('uniquePin', UniquePIN, 365);
        if (window.location.pathname === '/ca/lp/legal-answering-service' || isFromLegalIntakeGuide) {
          hideRegisterFormAndShowThankYouSectionForLpPage(eventTarget);
        }

        if (window.location.pathname === '/ca/lp/legal-intake-service') {
          showPlansFold(UniquePIN);
        }

        if (window.location.pathname === '/ca/register' || '/ca/services/law-firm-virtual-receptionist' || isReferAFriendPage || isFromLegalIntakeGuide) {
          setEventCookieIfRequired();
          if (isFromLegalIntakeGuide) return;
          window.location.pathname = '/ca/plans';
        } else {
          window.location.pathname = '/ca/demo';
        }
      }
    }
  } catch (e) {
        console.error(e) // eslint-disable-line
    window.location.reload();
  }
}

function registrationCTAHandler(event) {
  event.preventDefault();
  let infoObj = {};
  if (event.target.id === 'lp-register-btn') {
    infoObj = lPRegisterLeadInfo;
  } else {
    infoObj = leadInfo;
  }
  if (isLeadInfoValid(infoObj)) {
    event.target.setAttribute('style', 'pointer-events: none;cursor: default;');
    event.target.parents('.form')[0].classList.add('is-action');
    const payload = Object.values(infoObj).reduce((prevValue, currentValue) => {
      const prevValueRef = prevValue;
      const { value, emittedBy } = currentValue;
      if (emittedBy === 'phone') {
        const { dialCode, nationalNumber } = currentValue;
        prevValueRef.countryCode = dialCode;
        prevValueRef.phone = nationalNumber;
      } else {
        prevValueRef[emittedBy] = value;
      }
      return prevValueRef;
    }, {});
    processLeadRegistration({
      ...payload,
      brandid: BRANDID,
      cookie: document.cookie,
      referrer: document.referrer || window.location.href,
      timezone: window.getUserTimezone && window.getUserTimezone(),
      ...(isReferAFriendPage && {
        reference: 'Referral',
        referrerContactId: getCookieValue('referrerContactId'),
      }),
      ...(isFromMailchimpEmailCampaign && { leadSource: ' - email campaign' }),
      ...(isFromLegalIntakeGuide && { leadSource: ' - lead magnet', tagName: 'lead magnet' }),
    }, event.target.id);
  } else if (infoObj && Object.keys(infoObj).length) {
    Object.values(infoObj).forEach((value) => {
      if (!value.valid && value.selector) {
        document.querySelector(value.selector).classList.add('is-invalid');
      }
    });
  }
}

if (registerBtn) registerBtn.addEventListener('click', registrationCTAHandler);
if (lPRegisterBtn) lPRegisterBtn.addEventListener('click', registrationCTAHandler);


if (!getCookieValue('isregistered') && lpPageCta) {
  if (window.location.pathname === '/ca/lp/legal-intake-service') {
    lpPageCta.removeAttribute('href');
    lpPageCta.addEventListener('click', () => {
      const lpIntakeRegisterFold = document.getElementById('intake-bottom-reg-fold');
      lpIntakeRegisterFold.scrollIntoView({ behavior: 'smooth' });
    });
  } else if (window.location.pathname === '/ca/lp/legal-answering-service') {
    lpPageCta.removeAttribute('href');
    lpPageCta.addEventListener('click', () => {
      const lpTopRegisterFold = document.getElementById('lp-top-reg-fold');
      if (lpTopRegisterFold && !lpTopRegisterFold.classList.contains('registered')) {
        lpTopRegisterFold.classList.remove('d-none');
        lpTopRegisterFold.scrollIntoView({ behavior: 'smooth' });
      }
    });
  }
}

window.addEventListener('pageshow', () => {
  if (isFromLegalIntakeGuide && getCookieValue('isregistered')) {
    if (document.querySelector('#lp-register-btn')) {
      hideRegisterFormAndShowThankYouSectionForLpPage('lp-register-btn');
    }
  }
});

// Intltel Input Accessibility
window.addEventListener('load', () => {
  const flagContainer = document.querySelector('.iti__flag-container');
  const selectedFlag = document.querySelector('.iti__selected-flag');
  const demoPhoneInput = document.querySelector('#demo-phone-field');

  if (flagContainer) {
    flagContainer.setAttribute('aria-label', 'Country code');
  }

  if (selectedFlag) {
    selectedFlag.setAttribute('role', 'button');
    selectedFlag.setAttribute('aria-haspopup', 'true');
    selectedFlag.setAttribute('tabindex', '-1');

    // For padding left issue
    if (demoPhoneInput) {
      const flagWidth = selectedFlag.querySelector('.iti__flag').offsetWidth;
      const dialCodeWidth = selectedFlag.querySelector('.iti__selected-dial-code').offsetWidth;
      const dropDownWidth = flagWidth + dialCodeWidth + 30;
      demoPhoneInput.style.paddingLeft = (dropDownWidth === 30) ? ''.concat(85, 'px') : ''.concat(dropDownWidth, 'px');
    }
  }
});
